/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * Icons
 */
import icons from './icons.js';

//import './index.toolbar';

import EditWooHelper from './edit.woo.helper';
import SaveWooHelper from './save.woo.helper';

registerBlockType( 'momothemes/momo-woo-helper-pro', {
    title: __( 'Woo Helper', 'momoacgwc' ),
    description: __( 'Woo Helper', 'momoacgwc' ),
    icon: icons.circle,
    keywords: [
        __( 'Helper', 'momoacgwc' ),
        __( 'AI', 'momoacgwc' ),
        __( 'MoMo', 'momoacgwc' ),
        __( 'Woo', 'momoacgwc' ),
        __( 'Woo Helper', 'momoacgwc' ),
    ],
    /**
     * @see ./edit.js
     */
    edit: EditWooHelper,

    /**
     * @see ./save.js
     */
    save: SaveWooHelper,
} );
